export { default as FEATURE_FLAGS } from "./featureFlags";
export { default as HOME_PHONE } from "./lib/homePhone";
export { default as OTP } from "./lib/otp";
export { default as META } from "./lib/meta";
export { default as REGEX } from "./lib/regex";
export { default as CRYPTO } from "./lib/crypto";
export { default as ROUTES } from "./lib/routes";
export { default as STORAGE_KEYS } from "./lib/storageKeys";
export { default as SETTINGS } from "./lib/settings";
export { default as UPLOAD } from "./lib/upload";
export const SILENT_AUDIO_WAV_BASE64 =
  "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
